// extracted by mini-css-extract-plugin
export default {"cartAmount":"cartAmount_cartAmount__ClNvq","activeMob":"cartAmount_activeMob__RpwJs","activeDesk":"cartAmount_activeDesk__SaCNP"};